<template>
  <div id="pageDashboard" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg4 sm12 xs1>
          <v-widget title="서버 상태" class="mt-2" style="font-weight: bold;">
            <div slot="widget-content">
              <div class="title text--darken-1">승객 서버 (ANDROID)</div>
              <div>
                <v-btn :color="changeServerStateColor(androidPassengerServer)" block @click="openDialogServer">{{ changeServerStateText(androidPassengerServer) }}</v-btn>
              </div>
              <v-card-title></v-card-title>
              <div class="title text--darken-1">승객 서버 (IOS)</div>
              <div>
                <v-btn :color="changeServerStateColor(iosPassengerServer)" block @click="openDialogServer">{{ changeServerStateText(iosPassengerServer) }}</v-btn>
              </div>
              <v-card-title></v-card-title>
              <div class="title text--darken-1">기사 서버</div>
              <div>
                <v-btn :color="changeServerStateColor(driverServer)" block @click="openDialogServer">{{ changeServerStateText(driverServer) }}</v-btn>
              </div>
            </div>
          </v-widget>     
        </v-flex>
          <v-dialog v-model="server.dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">서버 상태 변경</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-select
                        :items="serverState"
                        label="승객 서버 (ANDROID)"
                        v-model="serverModel.androidPassengerServer"
                        item-text="text"
                        item-value="state"
                        :menu-props="androidPassengerServer"
                        >
                      </v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                              :items="serverState"
                              label="승객 서버 (IOS)"
                              v-model="serverModel.iosPassengerServer"
                              item-text="text"
                              item-value="state"
                              :menu-props="iosPassengerServer"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="serverState"
                        label="기사 서버"
                        v-model="serverModel.driverServer"
                        item-text="text"
                        item-value="state"
                        :menu-props="driverServer"
                        >
                      </v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="승객서버 비운영시 문구"
                        v-model="serverModel.passengerServerDesc"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="기사서버 비운영시 문구"
                        v-model="serverModel.driverServerDesc"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="점검중 공통 문구 "
                        v-model="serverModel.maintenanceDesc"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn color="blue darken-1" flat @click="saveServer">적용</v-btn>
                <v-btn color="blue darken-1" flat @click="closeDialogServer">닫기</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import ServerState  from '@/api/serverState';
import ServerStateColor  from '@/api/serverStateColor';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      autoReload: false,
      androidPassengerServer: 'RUNNING',
      iosPassengerServer: 'RUNNING',
      driverServer: 'RUNNING',
      passengerServerDesc: '',
      driverServerDesc: '',
      maintenanceDesc: '',
      serverState: ServerState,
      serverStateColor: ServerStateColor,
      server: {
        dialog: false
      },
      serverModel: {
        androidPassengerServer: '',
        iosPassengerServer: '',
        driverServer: '',
        passengerServerDesc: '',
        driverServerDesc: '',
        maintenanceDesc: ''
      }
    };
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
    this.$el.getElementsByTagName('h4')[0].style = 'font-weight: bold';
    this.banbanCreated();
  },
  methods: {
    banbanCreated () {
      const prameters = {
        method: 'serverStates'
      };
      this.$store.dispatch('banbanAPI', prameters)
        .then(({ data }) => {
          this.driverServer = data.driverServer;
          this.androidPassengerServer = data.passengerServer;
          this.iosPassengerServer = data.iosPassengerServer;
          this.passengerServerDesc = data.passengerServerDesc;
          this.driverServerDesc = data.driverServerDesc;
          this.maintenanceDesc = data.maintenanceDesc;
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    changeServerStateColor (state) {
      for (let i = 0; i < this.serverStateColor.length; i++) {
        if (state === this.serverStateColor[i].state) {
          return this.serverStateColor[i].text;
        }
      }
    },
    changeServerStateText (state) {
      for (let i = 0; i < this.serverState.length; i++) {
        if (state === this.serverState[i].state) {
          return this.serverState[i].text;
        }
      }
    },
    openDialogServer () {
      this.serverModel.androidPassengerServer = this.androidPassengerServer;
      this.serverModel.iosPassengerServer = this.iosPassengerServer;
      this.serverModel.driverServer = this.driverServer;
      this.serverModel.passengerServerDesc = this.passengerServerDesc;
      this.serverModel.driverServerDesc = this.driverServerDesc;
      this.serverModel.maintenanceDesc = this.maintenanceDesc;
      this.server.dialog = true;
    },
    closeDialogServer () {
      this.server.dialog = false;
    },
    saveServer () {
      const prameters = {
        method: 'updateStates',
        driverServer: this.serverModel.driverServer,
        passengerServer: this.serverModel.androidPassengerServer,
        iosPassengerServer: this.serverModel.iosPassengerServer,
        passengerServerDesc: this.serverModel.passengerServerDesc,
        driverServerDesc: this.serverModel.driverServerDesc,
        maintenanceDesc: this.serverModel.maintenanceDesc
      };
      this.$store.dispatch('banbanAPI', prameters)
        .then(({ data }) => {
          this.server.dialog = false;
          this.banbanCreated();
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/server/ServerState.vue